import { useEffect, useRef, useState } from "react";
import {
  apiRequest,
  getLegacyUrl,
  initializeAuth,
  getKeycloakSession,
  loginWithKeycloak,
  logoutFromKeycloak,
} from "./api";

import ConfigurationView from "./apbot/configurations/ConfigurationView";
import NonPoConfigurationView from "./apbot/configurations/NonPoConfigurationView";
import CommonConfigurationView from "./apbot/configurations/CommonConfigurationView";
import ApConfigurationView from "./apbot/configurations/ApConfigurationView";

import GLCodesView from "./apbot/settings/apbotposettings/GLCodesView";
import CheckerExceptionApprovalView from "./apbot/checkerspages/CheckerExceptionApprovalView";
import CheckerGeneratedView from "./apbot/checkerspages/CheckerGeneratedView";
import CheckerHoldView from "./apbot/checkerspages/CheckerHoldView";
import CheckerNoMigoView from "./apbot/checkerspages/CheckerNoMigoView";
import CheckerPendingAssignmentView from "./apbot/checkerspages/CheckerPendingAssignmentView";
import CheckerPendingView from "./apbot/checkerspages/CheckerPendingView";
import CheckerReadyView from "./apbot/checkerspages/CheckerReadyView";
import CheckerRejectedView from "./apbot/checkerspages/CheckerRejectedView";
import CheckerPendingTeamView from "./apbot/checkerspages/CheckerPendingTeamView";

import MappingHeadersView from "./apbot/settings/apbotposettings/MappingHeadersView";
import CommonMappingHeadersView from "./apbot/settings/enterpriseSettings/CommonMappingHeadersView";
import NonPoMappingHeadersView from "./apbot/settings/apbotnonposettings/NonPoMappingHeadersView";
import ApMappingHeadersView from "./apbot/settings/apbotcommonsettings/ApMappingHeadersView";

import InvoiceDisplayView from "./InvoiceDisplayView";
import ProcessorHoldView from "./apbot/processorpages/ProcessorHoldView";
import ProcessorGeneratedView from "./apbot/processorpages/ProcessorGeneratedView";
import ProcessorExportTemplatesView from "./apbot/processorpages/ProcessorExportTemplatesView";
import ProcessorMandatoryInfoView from "./apbot/processorpages/ProcessorMandatoryInfoView";
import ProcessorPendingApprovalView from "./apbot/processorpages/ProcessorPendingApprovalView";
import ProcessorRejectedView from "./apbot/processorpages/ProcessorRejectedView";
import ProcessorNoMigoView from "./apbot/processorpages/ProcessorNoMigoView";
import ProcessorPendingActionsView from "./apbot/processorpages/ProcessorPendingActionsView";
import ProcessorReadyView from "./apbot/processorpages/ProcessorReadyView";
import ProcessorUploadDataView from "./apbot/processorpages/ProcessorUploadDataView";
import TestDataView from "./apbot/processorpages/TestDataView";

import TestDataView from "./TeamsView";

import ApprovalMatrix from "./apbot/settings/apbotposettings/ApprovalMatrix";
import SignupView from "./SignupView";
import TeamsView from "./TeamsView";
import TemplateSettingView from "./apbot/settings/apbotposettings/TemplateSettingView";

import UploadHeadersView from "./apbot/settings/apbotposettings/UploadHeadersView";
import CommonUploadHeadersView from "./apbot/settings/enterpriseSettings/CommonUploadHeadersView"
import ApUploadHeadersView from "./apbot/settings/apbotcommonsettings/ApUploadHeadersView"

import UploaderUploadInvoiceView from "./UploaderUploadInvoiceView";
import UploaderInvoiceStatusView from "./UploaderInvoiceStatusView";

import HSNSACMasterView from "./apbot/settings/enterpriseSettings/HSNSACMasterView";

import UsersView from "./UsersView";

import UserRightsView from "./apbot/settings/apbotposettings/UserRightsView";
import ApUserRightsView from "./apbot/settings/apbotcommonsettings/ApUserRightsView";
import PoUserRightsView from "./apbot/settings/apbotcommonsettings/PoUserRightsView";

import VerifyOtpView from "./VerifyOtpView";


// Invoice Approval Views 
import InvoiceAppConfiguration from "./InvoiceApproval/InvoiceAppConfiguration";
import InvoiceApprovalMatrixPOView from "./InvoiceApproval/InvoiceApprovalMatrixPOView";
import InvoiceApprovalMatrixNonPOView from "./InvoiceApproval/InvoiceApprovalMatrixNonPOView";
import InvoiceTypesView from "./InvoiceApproval/InvoiceTypesView";
import ChecklistsView from "./InvoiceApproval/ChecklistsView";
import ConditionsPOView from "./InvoiceApproval/Conditions_POView";
import ConditionsNonPOView from "./InvoiceApproval/Conditions_Non-POView";
import InitiatorView from "./InvoiceApproval/InitiatorView";
import ApproverDashboard from "./InvoiceApproval/ApproverDashboard";
import InvCommonMappingHeadersView from "./InvoiceApproval/CommonMappingHeadersView";
import InvCommonUploadHeadersView from "./InvoiceApproval/CommonUploadHeadersView";
import InvoiceUploadDataView from "./InvoiceApproval/InvoiceUploadDataView";
import AdditionalReportsView from "./InvoiceApproval/AdditionalReportsView";





const superUserNavGroups = [
  {
    key: "common_settings",
    label: "Enterprise Level Settings",
    children: [
      { key: "common_configuration", label: "Configuration", mode: "internal" },
      { key: "common_upload_headers", label: "Upload Headers", mode: "internal" },
      { key: "common_header_mapping", label: "Header Mapping", mode: "internal" },
      { key: "hsn_sac_masters", label: "HSN/SAC List", mode: "internal" },    
    ],
  },

  {
    key: "miro_app_settings",
    label: "AP Bot Settings",
    children: [
      {
        key: "ap_common_settings",
        label: "AP Bot Common Settings",
        children: [
          { key: "ap_configuration", label: "Configuration", mode: "internal" },
          { key: "ap_upload_headers", label: "Upload Headers", mode: "internal" },
          { key: "ap_header_mapping", label: "Header Mapping", mode: "internal" },
          { key: "ap_user_rights", label: "User Rights", mode: "internal" },
        ],
      },

      {
        key: "po_settings",
        label: "PO Settings",
        children: [
          { key: "po_configuration", label: "Configuration", mode: "internal" },
          { key: "po_template_setting", label: "Template Setting", mode: "internal" },
          { key: "po_gl_codes", label: "Unallocated Cost GL Codes", mode: "internal" },
          { key: "po_roles", label: "Approval Matrix", mode: "internal" },
          { key: "po_user_rights", label: "User Rights", mode: "internal" },
        ],
      },

      {
        key: "non_po_settings",
        label: "Non-PO Settings",
        children: [
          { key: "non_po_configuration", label: "Configuration", mode: "internal" },
          { key: "non_po_header_mapping", label: "Header Mapping", mode: "internal" },
          { key: "non_po_template_setting", label: "Template Setting", mode: "internal" },
          { key: "non_po_roles", label: "Approval Matrix", mode: "internal" },
          { key: "non_po_user_rights", label: "User Rights", mode: "internal" },
        ],
      },
    ],
  },

  {
    key: "invoice_app_settings",
    label: "Invoice Approval App Settings",
    children: [
      { key: "invoice_configuration", label: "Invoice Configuration", mode: "internal" },
      { key: "invoice_type", label: "Invoice Type", mode: "internal" },
      { key: "checklists", label: "Checklists", mode: "internal" },
      { key: "conditions_po", label: "Conditions_PO", mode: "internal" },
      { key: "conditions_non_po", label: "Conditions_Non-PO", mode: "internal" },
      { key: "approval_matrix_po", label: "Approval Matrix_PO", mode: "internal" },
      { key: "approval_matrix_non_po", label: "Approval Matrix_Non-PO", mode: "internal" },
      { key: "inv_headers_upload", label: "Upload Headers", mode: "internal" },
      { key: "inv_headers_mapping", label: "Map Headers", mode: "internal" },
      { key: "additional_reports", label: "Additional Reports", mode: "internal" },
      { key: "invoice_upload_data", label: "Upload Master Data", mode: "internal" },
    ],
  },
];

const processorNavItems = [
  { key: "processor_pending", label: "Pending Actions", mode: "internal" },
  {
    key: "processor_missing",
    label: "Mandatory Info Missing",
    mode: "internal",
  },
  {
    key: "processor_duplicate",
    label: "Not Found In Migo/Duplicate",
    mode: "internal",
  },
  { key: "processor_hold", label: "On Hold", mode: "internal" },
  {
    key: "processor_approval",
    label: "Pending For Approval",
    mode: "internal",
  },
  { key: "processor_rejected", label: "Rejected", mode: "internal" },
  { key: "processor_ready", label: "Ready For Template", mode: "internal" },
  {
    key: "processor_generated",
    label: "Template Generated",
    mode: "internal",
  },
  { key: "processor_upload", label: "Upload Data", mode: "internal" },
  { key: "processor_export", label: "Export Template", mode: "internal" },
  { key: "test_data", label: "Test Data", mode: "internal" },
];

const checkerNavItems = [
  {
    key: "checker_pending",
    label: "Pending Approval",
    mode: "internal",
  },
  // {
  //   key: "checker_assignment",
  //   label: "Pending Assignment",
  //   mode: "internal",
  // },
  {
    key: "checker_nomigo",
    label: "Invoice Number Approvals",
    mode: "internal",
  },
  {
    key: "checker_exceptions",
    label: "Exception Approval",
    mode: "internal",
  },
  {
    key: "checker_team",
    label: "Pending with Team",
    mode: "internal",
  },
  {
    key: "checker_hold",
    label: "On Hold",
    mode: "internal",
  },
  {
    key: "checker_rejected",
    label: "Rejected",
    mode: "internal",
  },
  {
    key: "checker_ready",
    label: "Ready For Template",
    mode: "internal",
  },
  {
    key: "checker_generated",
    label: "Template Generated",
    mode: "internal",
  },
];

const uploaderNavItems = [
  {
    key: "uploader_upload",
    label: "Upload Invoice",
    mode: "internal",
  },
  {
    key: "uploader_status",
    label: "Invoice Status",
    mode: "internal",
  },
];

const initiatorNavItems = [
  {
    key: "initiator_queue",
    label: "Initiator Queue",
    mode: "internal",
  },
];

const approverNavItems = [
  {
    key: "approver_dashboard",
    label: "Approver Dashboard",
    mode: "internal",
  },
];

const APP_LAUNCHER_ITEMS = [
  { name: "App1", host: "app1.ngrisetech.com", icon: "A1" },
  { name: "App2", host: "app2.ngrisetech.com", icon: "A2" },
  { name: "App3", host: "app3.ngrisetech.com", icon: "A3" },
  { name: "App4", host: "app4.ngrisetech.com", icon: "A4" },
  { name: "App5", host: "app5.ngrisetech.com", icon: "A5" },
];

const authQueryParams = new URLSearchParams(window.location.search);
const initialAuthScreen = authQueryParams.get("screen") === "verify-otp" ? "verify_otp" : "login";
const initialAuthEmail = authQueryParams.get("email") || "";
const initialStandaloneScreen = authQueryParams.get("screen") || "";
const initialResponseFile = authQueryParams.get("response_file") || "";
const ACTIVE_ROLE_STORAGE_KEY = "miro-active-role";
const ACTIVE_PANEL_STORAGE_KEY = "miro-active-panel";

function getDefaultPanel(role) {
  if ((role || "").toLowerCase() === "superuser") {
    return "configuration";
  }
  if ((role || "").toLowerCase() === "processor") {
    return "processor_pending";
  }
  if ((role || "").toLowerCase() === "checker") {
    return "checker_pending";
  }
  if ((role || "").toLowerCase() === "uploader") {
    return "uploader_upload";
  }
  if ((role || "").toLowerCase() === "initiator") {
    return "initiator_queue";
  }
  if ((role || "").toLowerCase() === "approver") {
    return "approver_dashboard";
  }
  return "overview";
}

function getSidebarItemsForRole(role, summary, session) {
  if (role === "SuperUser") {
    return superUserNavGroups.flatMap((group) => group.children || []);
  }
  if (role === "Processor") {
    return processorNavItems;
  }
  if (role === "Checker") {
    return checkerNavItems;
  }
  if (role === "Uploader") {
    return uploaderNavItems;
  }
  if (role === "Initiator") {
    return initiatorNavItems;
  }
  if (role === "Approver") {
    return approverNavItems;
  }
  return summary?.legacyLinks || session?.legacyLinks || [];
}

function findSidebarItem(items, panelKey) {
  for (const item of items) {
    // Check current item
    if (item.mode === "internal" && item.key === panelKey) {
      return true;
    }

    // Check nested children recursively
    if (item.children?.length) {
      const found = findSidebarItem(item.children, panelKey);

      if (found) {
        return true;
      }
    }
  }

  return false;
}

function isValidPanelForRole(role, panelKey) {
  if (!panelKey) {
    return false;
  }

  const sidebarItems = getSidebarItemsForRole(role, null, null);

  return findSidebarItem(sidebarItems, panelKey);
}

function readStoredActivePanel(role) {
  try {
    const storedRole = window.localStorage.getItem(ACTIVE_ROLE_STORAGE_KEY);
    const storedPanel = window.localStorage.getItem(ACTIVE_PANEL_STORAGE_KEY);
    if (storedRole === role && isValidPanelForRole(role, storedPanel)) {
      return storedPanel;
    }
  } catch {
    return "";
  }
  return "";
}

function saveActiveNavigation(role, panelKey) {
  try {
    window.localStorage.setItem(ACTIVE_ROLE_STORAGE_KEY, role || "");
    window.localStorage.setItem(ACTIVE_PANEL_STORAGE_KEY, panelKey || "");
  } catch {
    // Local storage can be unavailable in private/locked-down browser modes.
  }
}

function StatCard({ stat }) {
  return (
    <article className="stat-card">
      <div className="stat-card__label">{stat.label}</div>
      <div className="stat-card__value">{stat.value}</div>
      <p className="stat-card__description">{stat.description}</p>
    </article>
  );
}

function LinkCard({ link }) {
  return (
    <a className="link-card" href={getLegacyUrl(link.url)} target="_blank" rel="noreferrer">
      <span>{link.label}</span>
      <span className="link-card__arrow">Open</span>
    </a>
  );
}

function SidebarNav({ items, activeKey, onSelect }) {
  function handleExternalNavigation(item) {
    if (item.section) {
      window.localStorage.setItem(item.storageKey || "activeSection", item.section);
    }
  }

  return (
    <nav className="sidebar-nav">
      {items.map((item) =>
        item.mode === "group" ? (
          <div key={item.key || item.label} className="sidebar-nav__group-label">
            {item.label}
          </div>
        ) : item.mode === "internal" ? (
          <button
            key={item.key || item.label}
            className={`sidebar-nav__item sidebar-nav__item--button${activeKey === item.key ? " is-active" : ""}`}
            type="button"
            onClick={() => onSelect(item.key)}
          >
            <span>{item.label}</span>
          </button>
        ) : (
          <a
            key={item.key || item.url || item.label}
            className="sidebar-nav__item"
            href={getLegacyUrl(item.url)}
            target="_blank"
            rel="noreferrer"
            onClick={() => handleExternalNavigation(item)}
          >
            <span>{item.label}</span>
            <span className="sidebar-nav__meta">Open</span>
          </a>
        ),
      )}
    </nav>
  );
}

export default function App() {
  const appsMenuRef = useRef(null);
  const sessionMenuRef = useRef(null);
  const [session, setSession] = useState(null);
  const [summary, setSummary] = useState(null);
  const [authScreen, setAuthScreen] = useState(initialAuthScreen);
  const [authEmail, setAuthEmail] = useState(initialAuthEmail);
  const [standaloneScreen] = useState(initialStandaloneScreen);
  const [standaloneResponseFile] = useState(initialResponseFile);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [invoiceDisplayFile, setInvoiceDisplayFile] = useState("");
  const [activePanel, setActivePanel] = useState("overview");
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedTeam, setSelectedTeam] = useState("");
  const [isAppsMenuOpen, setIsAppsMenuOpen] = useState(false);
  const [isSessionMenuOpen, setIsSessionMenuOpen] = useState(false);

  function selectPanel(panelKey, role = selectedRole || session?.roles?.[0] || "") {
    setActivePanel(panelKey);
    saveActiveNavigation(role, panelKey);
  }

  async function loadSession() {
    setLoading(true);
    try {
      const authenticated = await initializeAuth();
      if (!authenticated) {
        setSession({ authenticated: false, roles: [] });
        setSummary(null);
        return;
      }
      const keycloakSession = getKeycloakSession();
      const baseSession = {
        authenticated: keycloakSession.authenticated,
        roles: keycloakSession.roles,
        team: keycloakSession.teams,
        organizations: keycloakSession.organizations,
        fullName: keycloakSession.profile?.name || keycloakSession.profile?.username || "",
        email: keycloakSession.profile?.email || "",
        username: keycloakSession.profile?.username || "",
        company: { code: null, name: "" },
      };
      let dashboard = null;
      try {
        dashboard = await apiRequest("/dashboard/summary/");
        setSummary(dashboard);
      } catch (summaryError) {
        console.error(summaryError);
        setSummary(null);
      }

      const mergedSession = dashboard
        ? {
            ...baseSession,
            fullName: dashboard?.user?.fullName || baseSession.fullName,
            email: dashboard?.user?.email || baseSession.email,
            company: {
              code: null,
              name: dashboard?.companyName || "",
            },
          }
        : baseSession;
      setSession(mergedSession);
      const roles = keycloakSession.roles || [];

      const savedRole = sessionStorage.getItem("activeRole");
      const initialRole =
        savedRole && roles.includes(savedRole)
          ? savedRole
          : roles.find(
              (role) => (role || "").toLowerCase() === "superuser"
            )
            ? "SuperUser"
            : roles[0] || "";
            
      setSelectedRole(initialRole);
      setSelectedTeam((keycloakSession.teams || [])[0] || "");

      const storageKey = getPanelStorageKey(initialRole);
      const savedPanel = sessionStorage.getItem(storageKey);

      setActivePanel(
        savedPanel || getDefaultPanel(initialRole)
      );
    } catch (requestError) {
      setSession({ authenticated: false, roles: [] });
      setSummary(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadSession();
  }, []);

  useEffect(() => {
    function handlePointerDown(event) {
      if (!appsMenuRef.current?.contains(event.target)) {
        setIsAppsMenuOpen(false);
      }
      if (!sessionMenuRef.current?.contains(event.target)) {
        setIsSessionMenuOpen(false);
      }
    }

    if (isAppsMenuOpen || isSessionMenuOpen) {
      document.addEventListener("mousedown", handlePointerDown);
      document.addEventListener("touchstart", handlePointerDown);
    }

    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("touchstart", handlePointerDown);
    };
  }, [isAppsMenuOpen, isSessionMenuOpen, loading, session]);

  useEffect(() => {
    function handleEscape(event) {
      if (event.key === "Escape") {
        setInvoiceDisplayFile("");
      }
    }

    if (invoiceDisplayFile) {
      document.addEventListener("keydown", handleEscape);
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [invoiceDisplayFile]);

  async function handleLogout() {
    setSubmitting(true);
    try {
      await logoutFromKeycloak();
    } catch (requestError) {
      console.error(requestError);
    } finally {
      setSubmitting(false);
    }
  }

  if (loading) {
    return (
      <main className="app-shell app-shell--centered">
        <div className="loading-card">Loading Miro workspace…</div>
      </main>
    );
  }

  if (!session?.authenticated) {
    return (
      <main className="app-shell">
        <section className="hero-panel">
          <div className="hero-panel__badge">MiroFlow AP</div>
          <h1>From upload to approval, streamline invoice processing with role-based AP control.</h1>
          <p>
            MiroFlow AP is a role-based accounts payable workflow platform that streamlines
            invoice upload, validation, exception handling, approvals, template generation,
            and financial processing across uploader, processor, checker, and admin teams.
          </p>
          <div className="hero-panel__list">
            <span>Session-based login</span>
            <span>React company signup</span>
            <span>Role-aware dashboard</span>
            <span>Legacy workflow links</span>
          </div>
        </section>

        {authScreen === "signup" ? (
          <SignupView
            onBackToLogin={() => setAuthScreen("login")}
            onOtpSent={(email) => {
              setAuthEmail(email);
              setAuthScreen("verify_otp");
              window.history.replaceState({}, "", `/?screen=verify-otp&email=${encodeURIComponent(email)}`);
            }}
          />
        ) : authScreen === "verify_otp" ? (
          <VerifyOtpView
            email={authEmail}
            onBackToSignup={() => {
              setAuthScreen("signup");
              window.history.replaceState({}, "", "/");
            }}
            onVerificationSuccess={(redirectUrl) => {
              window.location.href = getLegacyUrl(redirectUrl || "/password-reset-confirmation/");
            }}
          />
        ) : (
          <section className="auth-panel">
            <div className="auth-panel__header">
              <p className="eyebrow">Sign In</p>
              <h2>Continue to your invoice workspace</h2>
            </div>

            <div className="auth-form">
              <button
                className="primary-button"
                type="button"
                onClick={() => loginWithKeycloak()}
              >
                Sign in with Keycloak
              </button>

              <p className="auth-form__hint">
                You will be redirected to Keycloak to sign in.
              </p>
            </div>

            <button
              className="secondary-link secondary-link--button"
              type="button"
              onClick={() => {
                setAuthScreen("signup");
                window.history.replaceState({}, "", "/");
              }}
            >
              Need an account? Create a company workspace
            </button>
          </section>
        )}
      </main>
    );
  }

  if (session?.authenticated && standaloneScreen === "invoice-display") {
    return <InvoiceDisplayView responseFile={standaloneResponseFile} />;
  }

  const activeRole = selectedRole || session.roles[0] || "";
  const activeTeam = selectedTeam || session.team?.[0] || "";
  const sidebarItems = getSidebarItemsForRole(activeRole, summary, session);



  function getPanelStorageKey(role) {
    return `activePanel_${(role || "").toLowerCase()}`;
  }

  // function SuperUserSidebarNav({ groups, activeKey, onSelect }) {
  //   const [openGroup, setOpenGroup] = useState(null);

  //   useEffect(() => {
  //     const activeGroup = groups.find((group) =>
  //       group.children.some((item) => item.key === activeKey)
  //     );

  //     if (activeGroup) {
  //       setOpenGroup(activeGroup.key);
  //     }
  //   }, [activeKey, groups]);

  //   const handleGroupClick = (groupKey) => {
  //     setOpenGroup((current) =>
  //       current === groupKey ? null : groupKey
  //     );
  //   };

  //   return (
  //     <div className="superuser-sidebar-nav">
  //       {groups.map((group) => {
  //         const isOpen = openGroup === group.key;

  //         const hasActiveChild = group.children.some(
  //           (item) => item.key === activeKey
  //         );

  //         return (
  //           <div
  //             key={group.key}
  //             className={`superuser-sidebar-group ${
  //               isOpen ? "is-open" : ""
  //             } ${hasActiveChild ? "has-active-child" : ""}`}
  //           >
  //             <button
  //               type="button"
  //               className="superuser-sidebar-group-button"
  //               onClick={() => handleGroupClick(group.key)}
  //             >
  //               <span>{group.label}</span>

  //               <span
  //                 className={`superuser-sidebar-arrow ${
  //                   isOpen ? "is-open" : ""
  //                 }`}
  //               >
  //                 ›
  //               </span>
  //             </button>

  //             {isOpen && (
  //               <div className="superuser-sidebar-submenu">
  //                 {group.children.map((item) => (
  //                   <button
  //                     key={item.key}
  //                     type="button"
  //                     className={`superuser-sidebar-submenu-item ${
  //                       activeKey === item.key ? "active" : ""
  //                     }`}
  //                     onClick={() => onSelect(item.key)}
  //                   >
  //                     {item.label}
  //                   </button>
  //                 ))}
  //               </div>
  //             )}
  //           </div>
  //         );
  //       })}
  //     </div>
  //   );
  // }

  function SuperUserSidebarNav({ groups, activeKey, onSelect }) {
    const [openItems, setOpenItems] = useState({});

    const hasActiveItem = (item) => {
      if (item.key === activeKey) {
        return true;
      }

      if (item.children?.length) {
        return item.children.some((child) => hasActiveItem(child));
      }

      return false;
    };

    useEffect(() => {
      const newOpenItems = {};

      const collectParents = (items) => {
        items.forEach((item) => {
          if (item.children?.length) {
            const containsActive = item.children.some((child) =>
              hasActiveItem(child)
            );

            if (containsActive) {
              newOpenItems[item.key] = true;
            }

            collectParents(item.children);
          }
        });
      };

      collectParents(groups);

      setOpenItems(newOpenItems);
    }, [activeKey, groups]);

    const handleItemClick = (item) => {
      if (item.children?.length) {
        setOpenItems((current) => ({
          ...current,
          [item.key]: !current[item.key],
        }));

        return;
      }

      onSelect(item.key);
    };

    const renderItems = (items, level = 0) => {
      return items.map((item) => {
        const hasChildren = item.children?.length > 0;
        const isOpen = !!openItems[item.key];
        const isActive = item.key === activeKey;
        const containsActive = hasActiveItem(item);

        // Top-level item
        if (level === 0) {
          return (
            <div
              key={item.key}
              className={`superuser-sidebar-group ${
                isOpen ? "is-open" : ""
              } ${containsActive ? "has-active-child" : ""}`}
            >
              <button
                type="button"
                className="superuser-sidebar-group-button"
                onClick={() => handleItemClick(item)}
              >
                <span>{item.label}</span>

                {hasChildren && (
                  <span
                    className={`superuser-sidebar-arrow ${
                      isOpen ? "is-open" : ""
                    }`}
                  >
                    ›
                  </span>
                )}
              </button>

              {hasChildren && isOpen && (
                <div className="superuser-sidebar-submenu">
                  {renderItems(item.children, level + 1)}
                </div>
              )}
            </div>
          );
        }

        // Nested item
        return (
          <div
            key={item.key}
            className={`superuser-sidebar-nested-item level-${level} ${
              isOpen ? "is-open" : ""
            } ${containsActive ? "has-active-child" : ""}`}
          >
            <button
              type="button"
              className={`superuser-sidebar-submenu-item ${
                hasChildren ? "has-children" : ""
              } ${isActive ? "active" : ""}`}
              onClick={() => handleItemClick(item)}
            >
              <span>{item.label}</span>

              {hasChildren && (
                <span
                  className={`superuser-sidebar-arrow ${
                    isOpen ? "is-open" : ""
                  }`}
                >
                  ›
                </span>
              )}
            </button>

            {hasChildren && isOpen && (
              <div className="superuser-sidebar-nested-submenu">
                {renderItems(item.children, level + 1)}
              </div>
            )}
          </div>
        );
      });
    };

    return (
      <div className="superuser-sidebar-nav">
        {renderItems(groups)}
      </div>
    );
  }

  const handlePanelChange = (panel) => {
    setActivePanel(panel);

    const storageKey = getPanelStorageKey(selectedRole);
    sessionStorage.setItem(storageKey, panel);
  };

  function handleDashboardClickCapture(event) {
    const link = event.target.closest('a[href*="/invoice-display/?response_file="]');
    if (!link) {
      return;
    }

    const href = link.getAttribute("href");
    if (!href) {
      return;
    }

    const parsedUrl = new URL(href, window.location.origin);
    const responseFile = parsedUrl.searchParams.get("response_file");
    if (!responseFile) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    setInvoiceDisplayFile(responseFile);
  }

  return (
    <main className="dashboard-shell">
      <section className="dashboard-topbar dashboard-topbar--compact">
        <div>
          <p className="eyebrow">Connected Session</p>
          <h1>{summary?.companyName || session.company.name}</h1>
          <p className="dashboard-subtitle">
            Signed in as {session.fullName}. Viewing {activeRole || "assigned"} access
            {activeTeam ? ` for ${activeTeam}.` : "."}
          </p>
        </div>

        <div className="dashboard-topbar__controls">
          <label className="header-switcher">
            <span>Role</span>
            <select
              value={activeRole}
              onChange={(event) => {
                const nextRole = event.target.value;

                setSelectedRole(nextRole);
                sessionStorage.setItem("activeRole", nextRole);

                const storageKey = getPanelStorageKey(nextRole);
                const savedPanel = sessionStorage.getItem(storageKey);

                setActivePanel(
                  savedPanel || getDefaultPanel(nextRole)
                );
              }}
              disabled={session.roles.length <= 1}
            >
              {session.roles.map((role) => (
                <option key={role} value={role}>
                  {role}
                </option>
              ))}
            </select>
          </label>

          <label className="header-switcher">
            <span>Team</span>
            <select
              value={activeTeam}
              onChange={(event) => {
                setSelectedTeam(event.target.value);
              }}
              disabled={(session.team || []).length <= 1}
            >
              {(session.team || []).length ? (
                session.team.map((team) => (
                  <option key={team} value={team}>
                    {team}
                  </option>
                ))
              ) : (
                <option value="">No team assigned</option>
              )}
            </select>
          </label>

          <details
            ref={appsMenuRef}
            className="apps-menu"
            open={isAppsMenuOpen}
          >
            <summary
              className="apps-menu__trigger"
              onClick={(event) => {
                event.preventDefault();
                setIsAppsMenuOpen((current) => !current);
              }}
              aria-label="Open applications menu"
            >
              <span className="apps-menu__dots" aria-hidden="true">
                <span />
                <span />
                <span />
                <span />
                <span />
                <span />
              </span>
            </summary>

            <div className="apps-menu__panel">
              {APP_LAUNCHER_ITEMS.map((app) => (
                <a
                  key={app.name}
                  className="apps-menu__item"
                  href={`https://${app.host}`}
                  target="_blank"
                  rel="noreferrer"
                  onClick={() => setIsAppsMenuOpen(false)}
                >
                  <span className="apps-menu__item-icon" aria-hidden="true">
                    {app.icon}
                  </span>
                  <span>{app.name}</span>
                </a>
              ))}
            </div>
          </details>

          <details
            ref={sessionMenuRef}
            className="session-menu"
            open={isSessionMenuOpen}
          >
            <summary
              className="session-menu__trigger"
              onClick={(event) => {
                event.preventDefault();
                setIsSessionMenuOpen((current) => !current);
              }}
            >
              {session.fullName}
            </summary>

            <div className="session-menu__panel">
              <button
                className="primary-button session-menu__logout"
                type="button"
                onClick={() => {
                  setIsSessionMenuOpen(false);
                  handleLogout();
                }}
                disabled={submitting}
              >
                {submitting ? "Logging out..." : "Log Out"}
              </button>
            </div>
          </details>
        </div>
      </section>

      <section className="dashboard-layout dashboard-layout--compact" onClickCapture={handleDashboardClickCapture}>
        <aside className="dashboard-sidebar dashboard-sidebar--compact">
          <div className="workspace-panel workspace-panel--compact workspace-panel--sidebar">
            <p className="eyebrow">Navigation</p>
            <h2>Dashboard Options</h2>
            {activeRole === "SuperUser" ? (
              <SuperUserSidebarNav
                groups={superUserNavGroups}
                activeKey={activePanel}
                onSelect={handlePanelChange}
              />
            ) : (
              <SidebarNav
                items={sidebarItems}
                activeKey={activePanel}
                onSelect={handlePanelChange}
              />
            )}
          </div>
        </aside>

        <section className="dashboard-main dashboard-main--workspace">
          {activePanel === "common_configuration" && activeRole === "SuperUser" ? (
            <CommonConfigurationView />
          ) : activePanel === "po_configuration" && activeRole === "SuperUser" ? (
            <ConfigurationView />
          ) : activePanel === "non_po_configuration" && activeRole === "SuperUser" ? (
            <NonPoConfigurationView />
          ) : activePanel === "ap_configuration" && activeRole === "SuperUser" ? (
            <ApConfigurationView />
          ) : activePanel === "invoice_configuration" && activeRole === "SuperUser" ? (
            <InvoiceAppConfiguration onBack={() => selectPanel("configuration", activeRole)} />
          )
            : activePanel === "processor_pending" && activeRole === "Processor" ? (
            <ProcessorPendingActionsView />
          ) : activePanel === "processor_missing" && activeRole === "Processor" ? (
            <ProcessorMandatoryInfoView />
          ) : activePanel === "processor_duplicate" && activeRole === "Processor" ? (
            <ProcessorNoMigoView />
          ) : activePanel === "processor_hold" && activeRole === "Processor" ? (
            <ProcessorHoldView />
          ) : activePanel === "processor_approval" && activeRole === "Processor" ? (
            <ProcessorPendingApprovalView />
          ) : activePanel === "processor_rejected" && activeRole === "Processor" ? (
            <ProcessorRejectedView />
          ) : activePanel === "processor_ready" && activeRole === "Processor" ? (
            <ProcessorReadyView />
          ) : activePanel === "processor_generated" && activeRole === "Processor" ? (
            <ProcessorGeneratedView />
          ) : activePanel === "processor_upload" && activeRole === "Processor" ? (
            <ProcessorUploadDataView />
          ) : activePanel === "processor_export" && activeRole === "Processor" ? (
            <ProcessorExportTemplatesView />
          ) : activePanel === "test_data" && activeRole === "Processor" ? (
            <TestDataView />
          ) : activePanel === "checker_pending" && activeRole === "Checker" ? (
            <CheckerPendingView />
          ) : activePanel === "checker_assignment" && activeRole === "Checker" ? (
            <CheckerPendingAssignmentView />
          ) : activePanel === "checker_nomigo" && activeRole === "Checker" ? (
            <CheckerNoMigoView />
          ) : activePanel === "checker_exceptions" && activeRole === "Checker" ? (
            <CheckerExceptionApprovalView />
          ) : activePanel === "checker_hold" && activeRole === "Checker" ? (
            <CheckerHoldView />
          ) : activePanel === "checker_rejected" && activeRole === "Checker" ? (
            <CheckerRejectedView />
          ) : activePanel === "checker_ready" && activeRole === "Checker" ? (
            <CheckerReadyView />
          ) : activePanel === "checker_generated" && activeRole === "Checker" ? (
            <CheckerGeneratedView />
          ) : activePanel === "checker_team" && activeRole === "Checker" ? (
            <CheckerPendingTeamView />
          ) : activePanel === "upload_headers" && activeRole === "SuperUser" ? (
            <UploadHeadersView />
          ) : activePanel === "ap_upload_headers" && activeRole === "SuperUser" ? (
            <ApUploadHeadersView />
          ) : activePanel === "common_upload_headers" && activeRole === "SuperUser" ? (
            <CommonUploadHeadersView />
          ) : activePanel === "hsn_sac_masters" && activeRole === "SuperUser" ? (
            <HSNSACMasterView />
          ) : activePanel === "non_po_upload_headers" && activeRole === "SuperUser" ? (
            <NonPoUploadHeadersView />
          ) : activePanel === "ap_header_mapping" && activeRole === "SuperUser" ? (
            <ApMappingHeadersView />
          ) : activePanel === "header_mapping" && activeRole === "SuperUser" ? (
            <MappingHeadersView />
          ) : activePanel === "common_header_mapping" && activeRole === "SuperUser" ? (
            <CommonMappingHeadersView />
          ) : activePanel === "non_po_header_mapping" && activeRole === "SuperUser" ? (
            <NonPoMappingHeadersView />
          ) : activePanel === "po_template_setting" && activeRole === "SuperUser" ? (
            <TemplateSettingView />
          ) : activePanel === "non_po_template_setting" && activeRole === "SuperUser" ? (
            <TemplateSettingView />
          ) : activePanel === "gl_codes" && activeRole === "SuperUser" ? (
            <GLCodesView />
          ) : activePanel === "po_gl_codes" && activeRole === "SuperUser" ? (
            <GLCodesView />
          ) : activePanel === "po_roles" && activeRole === "SuperUser" ? (
            <ApprovalMatrix />
          ) : activePanel === "non_po_roles" && activeRole === "SuperUser" ? (
            <ApprovalMatrix />
          ) : activePanel === "teams" && activeRole === "SuperUser" ? (
            <TeamsView />
          ) : activePanel === "users" && activeRole === "SuperUser" ? (
            <UsersView />
          ) : activePanel === "user_rights" && activeRole === "SuperUser" ? (
            <UserRightsView />
          ) : activePanel === "ap_user_rights" && activeRole === "SuperUser" ? (
            <ApUserRightsView />
          ) : activePanel === "po_user_rights" && activeRole === "SuperUser" ? (
            <PoUserRightsView />
          ) : activePanel === "invoice_type" && activeRole === "SuperUser" ? (
            <InvoiceTypesView />
          ) : activePanel === "checklists" && activeRole === "SuperUser" ? (
            <ChecklistsView />
          ) : activePanel === "conditions_po" && activeRole === "SuperUser" ? (
            <ConditionsPOView />
          ) : activePanel === "conditions_non_po" && activeRole === "SuperUser" ? (
            <ConditionsNonPOView />
          ) : activePanel === "approval_matrix_po" && activeRole === "SuperUser" ? (
            <InvoiceApprovalMatrixPOView />
          ) : activePanel === "approval_matrix_non_po" && activeRole === "SuperUser" ? (
            <InvoiceApprovalMatrixNonPOView />
          ) : activePanel === "inv_headers_upload" && activeRole === "SuperUser" ? (
            <InvCommonUploadHeadersView />
          ) : activePanel === "inv_headers_mapping" && activeRole === "SuperUser" ? (
            <InvCommonMappingHeadersView />
          ) : activePanel === "invoice_upload_data" && activeRole === "SuperUser" ? (
            <InvoiceUploadDataView />
          ) : activePanel === "additional_reports" && activeRole === "SuperUser" ? (
            <AdditionalReportsView />
          ) : activePanel === "uploader_upload" && activeRole === "Uploader" ? (
            <UploaderUploadInvoiceView
              selectedTeam={activeTeam}
              availableTeams={session.team || []}
            />
          ) : activePanel === "uploader_status" && activeRole === "Uploader" ? (
            <UploaderInvoiceStatusView />
          ) : activePanel === "initiator_queue" && activeRole === "Initiator" ? (
            <InitiatorView />
          ) : activePanel === "approver_dashboard" && activeRole === "Approver" ? (
            <ApproverDashboard />
          ) : (
            <>
              <section className="stats-grid">
                {(summary?.stats || []).map((stat) => (
                  <StatCard key={stat.key} stat={stat} />
                ))}
              </section>
            </>
          )}
        </section>
      </section>

      

      {invoiceDisplayFile ? (
        <div className="invoice-display-modal" role="presentation" onClick={() => setInvoiceDisplayFile("")}>
          <div
            className="invoice-display-modal__panel"
            role="dialog"
            aria-modal="true"
            aria-label="Invoice display"
            onClick={(event) => event.stopPropagation()}
          >
            <InvoiceDisplayView
              responseFile={invoiceDisplayFile}
              embedded
              onClose={() => setInvoiceDisplayFile("")}
            />
          </div>
          
        </div>
      ) : null}
    </main>
  );
}
